module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-light",
    class: {
      hide: !_vm.isVisible
    },
    attrs: {
      "id": "tabbar"
    }
  }, [_c('div', {
    staticClass: "h7 light col-3 tab-conf-name"
  }), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b2163d3a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/components/partials/TabBar.vue
// module id = 658
// module chunks = 0